import React from 'react';

import Stack from '@mui/material/Stack';

import GuideInfoBox from '../components/GuideInfoBox';
import GuideMockButton from '../components/GuideMockButton';
import GuideMockContainer from '../components/GuideMockContainer';
import GuidePageLayout from '../components/GuidePageLayout';
import GuideSection from '../components/GuideSection';
import GuideStepList from '../components/GuideStepList';
import GuideTable from '../components/GuideTable';

const GuideContractRequestManage: React.FC = () => {
  return (
    <GuidePageLayout
      title="契約申請の修正・対応・取消を行う"
      description="申請内容の修正と再申請、管理部門による対応、申請の取消を行います。"
      breadcrumbs={[{ label: '契約管理', path: '/guide/contract/overview' }]}
    >
      {/* 修正・再申請 */}
      <GuideSection title="申請内容を修正して再申請する（BUC-CT04）">
        <GuideTable
          headers={['条件', '内容']}
          rows={[
            ['対象ステータス', 'ADJUSTING（調整中）または REJECTED（否決）'],
            ['必要な権限', '管理者 / 管理部門 / 課長'],
          ]}
        />
        <GuideStepList
          steps={[
            { label: '契約申請一覧画面で対象申請を選択する' },
            {
              label: '申請詳細画面で「編集」ボタンを押下する',
              content: (
                <GuideMockContainer label="詳細画面のボタン">
                  <GuideMockButton label="編集" variant="outlined" />
                </GuideMockContainer>
              ),
            },
            { label: '内容を修正する' },
            { label: '「保存」ボタンを押下して修正を確定する' },
            {
              label: '「申請」ボタンを押下して申請を提出する',
              content: (
                <GuideMockContainer label="申請ボタン">
                  <GuideMockButton label="申請" />
                </GuideMockContainer>
              ),
            },
            { label: '申請者リスト・申請先リストを入力する' },
          ]}
        />
        <GuideInfoBox type="warning">
          否決された場合は否決理由を確認してから修正してください。
        </GuideInfoBox>
      </GuideSection>

      {/* 管理部門の対応 */}
      <GuideSection title="契約申請に対応する — 管理部門（BUC-CT05）">
        <GuideTable
          headers={['条件', '内容']}
          rows={[
            ['対象ステータス', 'SUBMITTED（申請中）'],
            ['必要な権限', '管理者 / 管理部門'],
          ]}
        />
        <GuideStepList
          steps={[
            { label: '契約申請一覧画面で未対応の申請を検索する' },
            { label: '対象申請の詳細を確認する' },
            {
              label: '「対応開始」ボタンを押下する',
              content: (
                <GuideMockContainer label="対応ボタン">
                  <GuideMockButton label="対応開始" />
                </GuideMockContainer>
              ),
            },
            { label: 'チェックリストの各項目を確認・チェックする' },
            {
              label: '全チェック完了後、「承認」または「否決」を選択する',
              content: (
                <GuideMockContainer label="承認/否決ボタン">
                  <Stack direction="row" spacing={1}>
                    <GuideMockButton label="承認" color="success" />
                    <GuideMockButton label="否決" color="error" />
                  </Stack>
                </GuideMockContainer>
              ),
            },
          ]}
        />
        <Stack spacing={1} sx={{ mt: 1 }}>
          <GuideInfoBox type="warning">
            承認するには全チェックリスト項目のチェックが完了している必要があります。
          </GuideInfoBox>
          <GuideInfoBox>
            新規申請の承認で契約が作成され、管理ID（CONT-連番）が自動発行されます。
          </GuideInfoBox>
          <GuideInfoBox>
            変更申請の承認で契約条件が更新されます（有効開始日から適用）。
          </GuideInfoBox>
          <GuideInfoBox>解除申請の承認で契約がTERMINATED（解除済み）になります。</GuideInfoBox>
        </Stack>
      </GuideSection>

      {/* 取消 */}
      <GuideSection title="契約申請を取り消す（BUC-CT06）">
        <GuideTable
          headers={['条件', '内容']}
          rows={[
            ['対象ステータス', 'ADJUSTING（調整中）または REJECTED（否決）'],
            ['必要な権限', '管理者 / 管理部門 / 課長'],
          ]}
        />
        <GuideStepList
          steps={[
            {
              label: '契約申請詳細画面で「取消」ボタンを押下する',
              content: (
                <GuideMockContainer label="取消ボタン">
                  <GuideMockButton label="取消" color="error" variant="outlined" />
                </GuideMockContainer>
              ),
            },
            { label: '確認ダイアログで「取消する」を選択する' },
          ]}
        />
        <GuideInfoBox type="warning">
          申請中（SUBMITTED）や対応中（IN_PROGRESS）の申請は取り消せません。
        </GuideInfoBox>
      </GuideSection>
    </GuidePageLayout>
  );
};

export default GuideContractRequestManage;
